// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"994fd82b","533":"fbcde2a3","599":"672b53ba","613":"fbcde2a3","764":"f41dccd4","837":"68376290"}[chunkId] + ".chunk.css";
};